import React from "react";
import { Table, Icon } from "@cloudscape-design/components";
import { UserPermission } from "../../../../../../domain/entities/UserProfileEntity";

interface PermissionMatrixProps {
    permissions: UserPermission[];
}

const COLUMN_DEFINITIONS = [
    {
        id: "module",
        header: "Module",
        cell: (item: UserPermission) => item.policy_name,
        sortingField: "policy_name",
    },
    {
        id: "create",
        header: "Create",
        cell: (item: UserPermission) => (
            <Icon
                name={item.policy?.create ? "status-positive" : "status-negative"}
                variant={item.policy?.create ? "success" : "error"}
            />
        ),
    },
    {
        id: "read",
        header: "Read",
        cell: (item: UserPermission) => (
            <Icon
                name={item.policy?.read ? "status-positive" : "status-negative"}
                variant={item.policy?.read ? "success" : "error"}
            />
        ),
    },
    {
        id: "update",
        header: "Update",
        cell: (item: UserPermission) => (
            <Icon
                name={item.policy?.update ? "status-positive" : "status-negative"}
                variant={item.policy?.update ? "success" : "error"}
            />
        ),
    },
    {
        id: "delete",
        header: "Delete",
        cell: (item: UserPermission) => (
            <Icon
                name={item.policy?.delete ? "status-positive" : "status-negative"}
                variant={item.policy?.delete ? "success" : "error"}
            />
        ),
    },
    {
        id: "assign",
        header: "Assign",
        cell: (item: UserPermission) => (
            <Icon
                name={item.policy?.assign ? "status-positive" : "status-negative"}
                variant={item.policy?.assign ? "success" : "error"}
            />
        ),
    },
];

const PermissionMatrix: React.FC<PermissionMatrixProps> = ({ permissions }) => {
    return (
        <Table
            columnDefinitions={COLUMN_DEFINITIONS}
            items={permissions}
            variant="embedded"
            wrapLines={false}
        />
    );
};

export default PermissionMatrix;
